<template>
    <div id="nature" class="wrap" v-if="natures">
        <h2>NATURE DE L'INTERVENTION *</h2>

        <div class="checkfull">
            <input type="checkbox" id="type-intervention" v-model="natures.contractuel" @change="updateNatures">
            <label class="btn check" for="type-intervention">
                Intervention contractuelle
                <i class="icon-valid"></i>
            </label>
        </div>

        <textarea placeholder="Description de la demande" id="desc-demande" v-model="natures.description" @change="updateNatures"></textarea>

        <div class="check">
            <input type="checkbox" id="assemblage" value="1" v-model="natures.assemblage" @change="updateNatures">
            <label class="btn check" for="assemblage">Assemblage de l'équipement
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check">
            <input type="checkbox" id="mise_en_service" value="1" v-model="natures.miseEnService" @change="checkCtrl('miseEnService')">
            <label class="btn check" for="mise_en_service">Mise en service de l'équipement
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check">
            <input type="checkbox" id="modification" value="1" v-model="natures.modification" ref="modif" @change="checkCtrl('modification')">
            <label class="btn check" for="modification">Modification de l'équipement
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check">
            <input type="checkbox" id="maintenance" value="1" v-model="natures.maintenance" @change="checkCtrl('maintenance')">
            <label class="btn check" for="maintenance">Maintenance de l'équipement
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check" v-if="gotFluide">
            <input type="checkbox" id="controle_per" value="1" v-model="natures.controlePeriodique" @change="updateNatures">
            <label class="btn check" for="controle_per">Contrôle d'étanchéité périodique
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check" v-if="gotFluide">
            <input type="checkbox" id="controle_nonper" value="1" v-model="natures.controleNonPeriodique" @change="updateNatures">
            <label class="btn check" for="controle_nonper">Contrôle d'étanchéité non périodique
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check">
            <input type="checkbox" id="demantelement" value="1" v-model="natures.demantelement" @change="updateNatures">
            <label class="btn check" for="demantelement">Démantèlement
                <i class="icon-valid"></i>
            </label>
        </div>

        <div class="check" v-if="isFibsdd">
            <input type="checkbox" id="retrofit" value="1" v-model="natures.retrofit" @change="retrofitCheck">
            <label class="btn check" for="retrofit">Rétrofit
                <i class="icon-valid"></i>
            </label>
        </div>

        <div v-show="natures.retrofit">
            <label>Nouveau fluide</label>
            <select v-model="natures.newFluide" @change="updateNatures">
                <option selected disabled>Sélectionnez un fluide</option>
                <option v-for="fluide in fluides" :key="fluide.id" :value="fluide.id">{{ fluide.nom }}{{ (fluide.nom_commercial) ? ' - ' +  fluide.nom_commercial : ''}}</option>
            </select>
        </div>

        <input type="text" class="dossier" placeholder="Autre ( 50 caractères max. )" maxlength="50" name="intervention_autre" value=""
               v-model="natures.autres" @change="updateNatures">

        <textarea v-if="isFibsdd" name="nature_observation" id="observations" placeholder="Observations sur cerfa" class="dossier"
                  style="overflow-y: hidden; height: 81px;" v-model="natures.observations" @change="updateNatures" maxlength="115">
    </textarea>

        <a href="javascript: void 0" id="next-start" class="btn btn-full next" @click="next">
            INTERVENIR
            <i class="icon-go"></i>
        </a>

    </div>
</template>

<script>
    import Fluide from '../../../../js/models/Fluide'

    export default {
        data() {
            return {
                fluides: null
            }
        },
        props: {
            natures: {
                assemblage: false,
                miseEnService: false,
                modification: false,
                maintenance: false,
                controlePeriodique: false,
                controleNonPeriodique: false,
                demantelement: false,
                retrofit: false,
                newFluide: null,
                autres: null,
                observations: null,
                description:null,
                contractuel: null,
            },
            gotFluide:null,
            isFibsdd:null
        },
        mounted() {
            this.fetchFluides()
        },
        methods: {
            checkCtrl(){
                if ( (this.natures.modification || this.natures.miseEnService || this.natures.maintenance) && this.gotFluide ) {
                    this.natures.controleNonPeriodique = true
                }
                this.updateNatures()
            },
            fetchFluides() {
                let fluide = new Fluide;
                fluide.getList(data => this.fluides = data.filter(f => !f.regenerated))
            },
            retrofitCheck(){
                this.natures.newFluide = null;
                if(this.natures.retrofit === true){
                    this.natures.controleNonPeriodique = true;
                    this.natures.modification = true
                }
                this.updateNatures()
            },
            updateNatures(){
                this.$emit('natureUpdated', this.natures)
            },
            next() {

                let errors = [];

                if (this.natures.retrofit === true && this.natures.newFluide === null) {
                    errors.push('Veuillez sélectionner le nouveau fluide suite au rétrofit')
                }

                let naturesRequired = this.natures;
                let countSelected = 0;

                for (let nature in naturesRequired) {
                    if (nature !== 'observations' && nature !== 'newFluide' && nature !== 'contractuel' && nature !== "description") {
                        if (naturesRequired[nature] !== null && naturesRequired[nature] !== '' && naturesRequired[nature] !== false) {
                            countSelected++
                        }
                    }
                }

                if (countSelected === 0) {
                    errors.push('Veuillez indiquer la nature de votre intervention')
                }

                if (errors.length === 0) {
                    this.$emit('goToIntervention');
                    this.$emit('natureUpdated', this.natures)
                } else {
                    swal('Erreur', errors[0], 'warning')
                }

            },
        }
    }
</script>

<style>
    #container-fi section .check input {
        display: none;
    }

    #container-fi section .check input:checked + label {
        color: white;
        background-color: #86bc24;
    }

    #container-fi section .check input:checked + label i {
        color: white;
    }

    #container-fi section .check label {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        margin-bottom: 5px;
        padding: 0 10px;
        font-family: "Open Sans";
        font-size: 1.5rem;
        font-weight: 400;
        text-transform: none;
        transition: all 250ms ease;
    }

    #container-fi section .check label i {
        position: absolute;
        right: 10px;
        font-size: 2.3rem;
        color: #999;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    #container-fi section #nature {
        padding-bottom: 20px;
    }

    #nature div.checkfull label.btn.check {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        font-size: 1.5rem;
        font-weight: 400;
        text-transform: none;
        margin-bottom: 15px;
        margin-top: 15px;
    }

    #nature div.checkfull label.btn.check i {
        position: absolute;
        top: 10px;
        font-size: 2.3rem;
        right: 15px;
        color: #999;
    }

    #nature div.checkfull input[type="checkbox"] {
        display: none;
    }

    #nature div.checkfull input:checked + label.btn.check {
        background-color: #86bc24;
        color: #fff;
    }

    #nature div.checkfull input:checked + label.btn.check i {
        color: #fff;
    }

    #container-fi section #nature input,
    #container-fi section #nature textarea {
        width: 100%;
        border-color: #999;
        margin-bottom: 5px;
    }

    #container-fi section #nature textarea {
        padding-top: 7px;
        min-height: 100px;
        height: auto;
        width: 100%;
        resize: none;
        box-sizing: border-box;
    }

    #container-fi section #nature a {
        margin-bottom: 20px;
        width: 200px;
        margin: auto;
        text-align: center;
        padding-left: 35px;
        font-size: 1.5rem;
        font-weight: 400;
        color: #fbfafa;
    }
</style>



// WEBPACK FOOTER //
// Nature.vue?b86936a0